/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Disabled_StatusInputs */

const fr_totp_disabled_status = /** @type {(inputs: Totp_Disabled_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'authentification à deux facteurs n'est pas activée`)
};

/**

* @param {Totp_Disabled_StatusInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_disabled_status = /** @type {((inputs?: Totp_Disabled_StatusInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Disabled_StatusInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_disabled_status(inputs)
});